import { Field } from "formik";
import { useEffect } from "react";
import Select from 'react-select';

export default function PatientAppointmentDetails({
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  handleSearchRadiusChange,
  values,
}) {
  useEffect(() => {
    console.log(values);
  }, [values]);

  const searchRadiusOptions = [
    { value: "5", label: "5" },
    { value: "10", label: "10" },
    { value: "15", label: "15" }
  ];

  return (
    <div className="space-y-6">
      {/* Zipcode + Search Radius */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {/* Zipcode */}
        <div className="md:col-span-5">
          <label
            htmlFor="apptZipcode"
            className="block text-sm font-semibold mb-2"
          >
            Zipcode <span className="text-red-500">*</span>
          </label>

          <Field
            name="apptZipcode"
            onChange={handleChange}
            onBlur={handleBlur}
            className={`
              w-full rounded-md border px-3 py-2
              focus:outline-none focus:ring-2 focus:ring-teal-500
              ${errors.apptZipcode && touched.apptZipcode
                ? "border-red-500"
                : "border-gray-300"
              }
            `}
          />

          {errors.apptZipcode && touched.apptZipcode && (
            <p className="text-red-500 text-sm mt-1">
              {errors.apptZipcode}
            </p>
          )}
        </div>

        {/* Spacer */}
        <div className="hidden md:block md:col-span-2" />

        {/* Search Radius */}
        <div className="md:col-span-5">
          <label
            htmlFor="searchRadius"
            className="block text-sm font-semibold mb-2"
          >
            Preferred Search Radius (in miles) <span className="text-red-500">*</span>
          </label>

          <Select
            name="searchRadius"
            className="focus:outline-none focus:ring-2 focus:ring-teal-500"
            options={searchRadiusOptions}
            value={values && values.searchRadius ? searchRadiusOptions.find(
              (option) => option.value === values.searchRadius
            ) : null}
            onChange={(selectedOption) => {
              const value = selectedOption ? selectedOption.value : "5";
              setFieldValue("searchRadius", value);
              if (handleSearchRadiusChange && selectedOption) {
                handleSearchRadiusChange(value);
              }
            }}
            onBlur={() => handleBlur({ target: { name: "searchRadius" } })}
            placeholder="Please select"
          />
        </div>
      </div>

      {/* Insurance */}
      <div>
        <label
          htmlFor="apptInsurance"
          className="block text-sm font-semibold mb-2"
        >
          Insurance
        </label>

        <Field
          name="apptInsurance"
          className={`
            w-full rounded-md border px-3 py-2
            focus:outline-none focus:ring-2 focus:ring-teal-500
            ${errors.apptInsurance && touched.apptInsurance
              ? "border-red-500"
              : "border-gray-300"
            }
          `}
        />
      </div>
    </div>
  );
}
